<script setup lang="ts">
import { SplideSlide } from '@splidejs/vue-splide'

const { title, injectedVariables } = defineProps<{
  title: StoryBlokHeading
  items: {
    subTitle: string
    title: string
    priceBefore: string
    priceAfter: string
    badgeTitle: string
    badgeAmount: string
    link: StoryBlokLink
    image: StoryBlokImage
  }[]
  itemShadow: boolean
  type: 'primary' | 'secondary'
  badgeColor?: string
  injectedVariables?: KeyValuePair[]
}>()

const injectedTitle = findTitleInArray(injectedVariables)
if (injectedTitle) title[0].text = injectedTitle
</script>

<template>
  <div class="w-full">
    <StoryblokHeading class="sm:text-center" :title="title" />
    <div
      :class="{ '<xs:-mx-2': itemShadow }"
      class="mt-6"
    >
      <AppSlider
        :item-shadow="itemShadow"
        :options="{
          type: 'loop',
          perPage: 3,
          fixedWidth: itemShadow ? '386px' : '370px',
          breakpoints: {
            1024: {
              perPage: 2,
            },
            768: {
              perPage: 2,
              fixedWidth: itemShadow ? '386px' : '356px',
            },
            640: {
              perPage: 1,
              fixedWidth: itemShadow ? '340px' : '324px',
            },
          },
        }"
      >
        <SplideSlide v-for="item in items">
          <div v-editable="item" class="splide__slide--product" :class="{ 'bg-white': !itemShadow }">
            <StoryblokLink v-bind="item.link" :class="{ 'item-shadow bg-white border relative border-transparent rounded-xl': itemShadow }">
              <div :class="{ 'p-4': itemShadow }">
                <div v-if="type === 'secondary'" class="flex justify-between items-center">
                  <div>
                    <span>{{ item.subTitle }}</span>
                    <h3>{{ item.title }}</h3>
                    <div class="mt-8 md:mt-4">
                      <span class="text-gray-dark">{{ item.priceBefore }}</span>
                      <h2>{{ item.priceAfter }}</h2>
                    </div>
                  </div>
                  <StoryblokImage :src="item.image" width="140" mwidth="110" />
                </div>

                <div v-else>
                  <span>{{ item.subTitle }}</span>
                  <h3>{{ item.title }}</h3>
                  <div
                    :class="badgeColor && `bg-${badgeColor}`"
                    class="right-0 top-5 absolute h-90px w-90px bg-primary flex items-center justify-center flex-col text-white rounded-full sm:right-5"
                  >
                    <span>{{ item.badgeTitle }}</span>
                    <span class="font-semibold text-large">{{ item.badgeAmount }}</span>
                  </div>
                  <StoryblokImage class="absolute right-0 bottom-5 sm:right-5" :src="item.image" width="160" height="80" mwidth="140" mheight="70" />
                  <div class="mt-8 md:mt-4">
                    <span class="text-gray-dark line-through">{{ item.priceBefore }}</span>
                    <h2>{{ item.priceAfter }}</h2>
                  </div>
                </div>
              </div>
            </StoryblokLink>
          </div>
        </SplideSlide>
      </AppSlider>
    </div>
  </div>
</template>

<style scoped>
.splide__slide--product {
  @apply border-1 transition border-transparent p-4 relative rounded-xl;
}

.item-shadow {
  box-shadow: 0 0 22px rgba(32, 28, 70, 0.05);
}
</style>
